import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#045864', // rgb(4, 88, 100)
    },
    secondary: {
      main: '#FF6B6B', // coral accent
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#0F172A',
      secondary: '#475569',
    },
  },
  shape: {
    borderRadius: 16,
  },
  spacing: (factor) => `${0.5 * factor}rem`,
  typography: {
    htmlFontSize: 16, // explicitly define to match root html font-size calculation base
    fontFamily:
      '"Inter", "Poppins", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  },
  components: {
    MuiModal: {
      defaultProps: {
        'aria-hidden': 'false',
      },
    },
    MuiDialog: {
      defaultProps: {
        'aria-hidden': 'false',
      },
    },
    MuiPopover: {
      defaultProps: {
        'aria-hidden': 'false',
      },
    },
    MuiMenu: {
      defaultProps: {
        'aria-hidden': 'false',
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 999,
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;

